import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const EditVehTyre = () => {
  useAuthRedirect();
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ fld_rate: "", fld_date: "" });

  const canEdit = hasPermission("Vehicle Diesel Rate", "edit");

  // Helper: format to dd/mm/yyyy
  const formatDMY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Fetch vehicle diesel rate
  useEffect(() => {
    const fetchVehicleType = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_dieselrate_api/${id}`
        );

        const rate = response.data.fld_rate || "";
        const rawDate = response.data.fld_date || null;

        setFormData({
          fld_rate: rate,
          fld_date: rawDate ? formatDMY(rawDate) : "",
        });
      } catch (error) {
        console.error("Error fetching vehicle type:", error);
      }
    };

    fetchVehicleType();
  }, [id]);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Convert back to YYYY-MM-DD before sending
      let [day, month, year] = formData.fld_date.split("/");
      const isoDate = `${year}-${month}-${day}`;

      await axios.put(
        `https://rfs2.infraconsoft.net.in/api/edit_dieselrate_api/${id}`,
        { ...formData, fld_date: isoDate }
      );

      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Diesel Rate Updated successfully.",
      });

      setFormData({ fld_rate: "", fld_date: "" });

      setTimeout(() => navigate("/vehicle_dieselrate_listing"), 500);
    } catch (error) {
      console.error("Error updating details:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Please Try Again",
      });
    }
  };

  if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Edit Diesel Rate</h2>
            <Link to="/vehicle_dieselrate_listing">
              <p className="back-button">
                <i className="fa-solid fa-backward"></i>Back
              </p>
            </Link>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Rate:</label>
                <input
                  type="text"
                  name="fld_rate"
                  value={formData.fld_rate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Date:</label>
                <input
                  type="text" // show in DD/MM/YYYY format
                  name="fld_date"
                  value={formData.fld_date}
                  onChange={handleChange}
                  readOnly
                />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditVehTyre;
